import { useEntities } from "@hooks/useEntities";
import { useMemo } from "react";
import { TransactionForLedgerAccount } from "@hooks/useTransactionLedgerAccount";

export function getEntityIdForGLAccount(
    transaction: TransactionForLedgerAccount,
    entities: Array<{ id: number; isBusiness: boolean }>,
): number | undefined {
    if (transaction.isBusiness) {
        return transaction.entity.id;
    }

    const financialAccountEntityId = transaction.financialAccount?.entityId;
    if (financialAccountEntityId != null) {
        const entity = entities.find((e) => e.id === financialAccountEntityId);
        if (entity?.isBusiness) {
            return entity.id;
        }
    }

    return undefined;
}

export function useEntityIdForGLAccount(
    transaction?: TransactionForLedgerAccount,
) {
    const entities = useEntities();

    return useMemo(
        () =>
            transaction
                ? getEntityIdForGLAccount(transaction, entities)
                : undefined,
        [transaction, entities],
    );
}
